import { render, staticRenderFns } from "./student_register.vue?vue&type=template&id=4a1ad7d7&scoped=true&"
import script from "./student_register.vue?vue&type=script&lang=js&"
export * from "./student_register.vue?vue&type=script&lang=js&"
import style0 from "./student_register.vue?vue&type=style&index=0&id=4a1ad7d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1ad7d7",
  null
  
)

export default component.exports